var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 106,
    viewBox: "0 0 106 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.9994 0C24.0273 0 0.433594 23.5823 0.433594 52.5962C0.433594 81.5492 24.0273 105.132 52.9994 105.132C81.9714 105.132 105.565 81.5492 105.565 52.5962C105.565 23.5823 81.9714 0 52.9994 0",
    fill: "#E06732"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1433 56.2933C72.991 56.4961 72.2807 57.3583 71.7226 57.9161L71.4181 58.2204C67.156 62.8355 56.5515 69.7834 51.1732 72.0148C51.1732 72.0655 47.9766 73.3841 46.4545 73.4348H46.2515C43.9175 73.4348 41.7357 72.1163 40.6195 69.9862C40.0106 68.8198 39.4525 65.4219 39.4017 65.3712C38.9451 62.3283 38.6406 57.6676 38.6406 52.5404C38.6406 47.1646 38.9451 42.296 39.5032 39.3039C39.5032 39.2531 40.0613 36.5145 40.4165 35.6017C40.9746 34.2831 41.9894 33.1674 43.2579 32.4574C44.2727 31.9502 45.3382 31.6967 46.4545 31.6967C47.6215 31.7474 49.8032 32.5132 50.6658 32.8631C56.3486 35.0945 67.2068 42.3975 71.3674 46.8603C72.0777 47.5703 72.8388 48.4325 73.0418 48.6354C73.9043 49.7511 74.361 51.1204 74.361 52.5962C74.361 53.9097 73.9551 55.2283 73.1433 56.2933",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/Play.104c2df973fb51486537fe53f78fb2a7.svg";
export { ForwardRef as ReactComponent };